import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { vpnConnectionStateHandler } from '../../../helpers/vpn-connection-state-handler';
import { useHistory } from 'react-router-dom';

import store from '../../../redux/store';
import { setPageHistoryPathname } from '../../../redux/actions/preferencesActions';

const VPN_RESTRICTED_COUNTRY = 'IN';

interface VpnValidationProps {
    children: React.ReactNode;
}

const VpnValidation: React.FC<VpnValidationProps> = ({ children }) => {

    const { agentDetails } = useSelector((state: any) => state.contactCenter)
    const [isValidating, setIsValidating] = useState(true);
    const history = useHistory();

    const { routingProfile = '' } = agentDetails || {};

    React.useEffect(() => {
        store.dispatch(setPageHistoryPathname(window.location.pathname));
    }, [history, window.location.pathname]);

    useEffect(() => {
        const isVoiceAgent = sessionStorage.getItem('isVoiceAgent') === 'true';
        const validateIP = async () => {
            try {
                const countryCode = await vpnConnectionStateHandler.getUserGeoCountry();
                sessionStorage.setItem('VpnCountryCode', countryCode)

                if (countryCode === VPN_RESTRICTED_COUNTRY) {
                    await vpnConnectionStateHandler.checkVpnStatus(true);
                }

            } catch (error) {
                console.error('VPN_DISCONNECT_CHECK - Error validating IP:', error);
            } finally {
                setIsValidating(false);
            }
        }

        if (routingProfile && isVoiceAgent) {
            console.log('VPN_DISCONNECT_CHECK - Calling VPN for Voice Agents');
            validateIP();
        } else {
            console.log('DEBUG - Skipping VPN validation for non-voice agents or missing routing profile');
            setIsValidating(false);
        }
    }, [history, routingProfile]);

    return <>{children}</>;
};

export default VpnValidation;